import React from 'react'

export const Certifications = () => {
  return (
    <div>Certifications</div>
  )
}
